import React__default from 'react';
import PT from 'prop-types';
import { TaktIdConsumer, createStormTaktId } from '@amzn/storm-ui';
import { n as numeric10Options, d as defaultOptions } from './defaultOptions-pw1XHNfj.js';
import { n as numeric10Values, v as values } from './values-D-xU0n7p.js';
import { S as StyledFieldset, b as StyledLegend, D as DescriptionContainer, c as DescriptionText } from './SentimentScale.styles-fdWAK_KI.js';
import { O as OptionsGroup } from './OptionsGroup-UYnE4OFN.js';
import { v as variant } from './Option/variant-K-YUik8y.js';

function SentimentScale({
  id,
  label,
  onChange,
  disabled = false,
  maxLabel,
  minLabel,
  options: externalOptions,
  value: selectedValue,
  variant = 'emoji',
  errorMessage,
  taktId,
  taktValue
}) {
  const values$1 = variant === 'numeric-10' ? numeric10Values : values;
  const options = externalOptions !== null && externalOptions !== void 0 ? externalOptions : variant === 'numeric-10' ? numeric10Options : defaultOptions;
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('sentiment-scale')
  }, () => /*#__PURE__*/React__default.createElement(StyledFieldset, null, /*#__PURE__*/React__default.createElement(StyledLegend, {
    id: id
  }, label), Array.isArray(options) && /*#__PURE__*/React__default.createElement(DescriptionContainer, null, /*#__PURE__*/React__default.createElement(DescriptionText, null, minLabel !== null && minLabel !== void 0 ? minLabel : options[0].label), /*#__PURE__*/React__default.createElement(DescriptionText, null, maxLabel !== null && maxLabel !== void 0 ? maxLabel : options[options.length - 1].label)), /*#__PURE__*/React__default.createElement(OptionsGroup, {
    id: id,
    variant: variant,
    errorMessage: errorMessage,
    disabled: disabled,
    options: values$1.filter((value, index) => !!options[index]).map((value, index) => ({
      id: options[index].id,
      label: options[index].label,
      disabled: options[index].disabled,
      value
    })),
    selectedValue: selectedValue,
    name: label,
    onChange: onChange
  })));
}
SentimentScale.propTypes = {
  id: PT.string.isRequired,
  label: PT.string.isRequired,
  onChange: PT.func.isRequired,
  disabled: PT.bool,
  options: PT.arrayOf(PT.shape({
    id: PT.string.isRequired,
    label: PT.string.isRequired,
    disabled: PT.bool
  })),
  value: PT.oneOfType([PT.number, PT.string]),
  variant: PT.oneOf(Object.values(variant))
};
SentimentScale.defaultProps = {
  disabled: false,
  options: undefined,
  value: undefined,
  variant: variant.emoji
};

export { SentimentScale as S };
//# sourceMappingURL=SentimentScale-B3zABql3.js.map
